export const language = "English";
export const signupurl = "https://bot.andaihub.com/ai-report";
export const blogurl = "https://blog.andaihub.com/";
export const careerurl = "https://andaiplatforms.zohorecruit.in/jobs/Careers";
export const youTubeUrl = "https://www.youtube.com/watch?v=2neKrBL3FME";
export const linkedinUrl = "https://www.linkedin.com/company/andaihub/";
export const instagramUrl = "https://www.instagram.com/andai_platforms";
export const contactUrl = "https://cal.com/andai";
export const twitterUrl = "https://x.com/AndAI_Platforms";
export const youtubeUrl =
  "https://www.youtube.com/channel/UCTIWevGEe7eyytOsMQZ1xSg";
export const mastodonUrl = "https://mastodon.social/@andai";
export const threadsUrl = "https://www.threads.net/@andai_platforms";
export const bskyUrl = "https://bsky.app/profile/andaii.bsky.social";
export const whatsUpUrl =
  "https://api.whatsapp.com/send/?phone=918484841871&text=Hi%2C+I+would+like+to+know+more+about+your+services.&type=phone_number&app_absent=0";
export const facebookUrl =
  "https://www.facebook.com/profile.php?id=61571240345224";
export const handleUrl = (url, event) => {
  if (event?.ctrlKey || event?.metaKey) {
    // Open in a new tab if CTRL (or CMD) key is pressed
    window.open(url, "_blank");
  } else {
    // Open in the same tab
    window.location.href = url;
  }
};

export const itemVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};
export const commonPaddingLeft = {
  xs: '2vw',    // More compact padding for mobile
  sm: '4vw',    // Slightly larger for tablets
  md: '5vw',    // Medium size for small laptops
  lg: '6vw',    // Default size for laptops/desktops
  xl: '13vw',    // Extra large screens (1536px+)
};
export const commonPaddingRight = {
  xs: '2vw',
  sm: '4vw',
  md: '5vw',
  lg: '6vw',
  xl: '13vw',    // Extra large screens
};
export const currentUrl = "window.location.href";
